import { get, post } from "@utils/axios";

const api = "invoice-management";
const paymentApi = "payment-management";

export const getInvoice = (invoice) => {
  return get(`${api}/get-invoice-data/${invoice}`);
}

/**
 * Publishable key + whether card payments are switched on. Never hardcode the
 * key here — it is configurable per deployment from admin settings.
 */
export const getPaymentConfig = () => {
  return get(`${paymentApi}/config`);
}

/**
 * Ask the server to open a PaymentIntent for a booking. The amount is worked out
 * server-side from the stored booking — deliberately nothing about the amount is
 * sent from here, because the old flow let the browser dictate what to charge.
 */
export const createPaymentIntent = (bookingId) => {
  return post(`${paymentApi}/intent`, { booking_id: bookingId });
}

/**
 * The Stripe webhook is what actually marks a booking paid, so after confirming
 * we poll this rather than trusting the browser's own result.
 */
export const getPaymentStatus = (bookingId) => {
  return get(`${paymentApi}/status/${bookingId}`);
}

export const refundBooking = (payload) => {
  return post(`${paymentApi}/refund`, payload);
}
